import { useDispatch, useSelector, useStore } from 'react-redux';

/**
 * Custom typed/standardized dispatch hook
 */
export const useAppDispatch = () => useDispatch();

/**
 * Custom standardized selector hook
 */
export const useAppSelector = useSelector;

/**
 * Custom standardized store hook
 */
export const useAppStore = useStore;
